$("select[name='tx_post_tag']").attr('id','tx_post_tag');

$("[data-name='tx_post_tag'] label.cvp-label").attr("for",'tx_post_tag');

$('div[data-name="tx_post_tag"] label').text('Search by tag');

$('.cvp-search-box label').text('Search by keyword');


// WEBPACK FOOTER //
// ./scripts/isoc_jquery.js